import { StateMachine } from '../misc/StateMachine.js';
import { OEvent } from '../misc/OEvent.js';
/**
 * Model's Base Class.
 */
export class Model {
    state;
    onUpdated = new OEvent();
    constructor() {
        this.state = new StateMachine();
        this.state.addState('Initialised');
        this.state.addState('Uninitialised');
        this.state.addEvent('init');
        this.state.addEvent('shutdown');
        this.state.addTransition('shutdown', 'Initialised', 'Uninitialised');
        this.state.addTransition('init', 'Uninitialised', 'Initialised');
        this.state.setInitialState('Uninitialised');
    }
}
//# sourceMappingURL=Model.js.map